import { createContext } from 'react';
import { ChangeVehicleHistoryContextProps } from './history-modal.types';

export const ChangeVehicleHistoryContext = createContext<ChangeVehicleHistoryContextProps>(
  {} as ChangeVehicleHistoryContextProps
);
